import _classCallCheck from "/home/catdrout/Desktop/gatsby-starter-mate/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Object.<string, Info>} Properties
 * @typedef {Object.<string, string>} Normal
 */
export var Schema =
/**
 * @constructor
 * @param {Properties} property
 * @param {Normal} normal
 * @param {string} [space]
 */
function Schema(property, normal, space) {
  _classCallCheck(this, Schema);

  this.property = property;
  this.normal = normal;

  if (space) {
    this.space = space;
  }
};
/** @type {Properties} */

Schema.prototype.property = {};
/** @type {Normal} */

Schema.prototype.normal = {};
/** @type {string|null} */

Schema.prototype.space = null;